export default __webpack_public_path__ + "static/media/web_developing.3a6b9048.gif";